var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "productcenter-page" },
    [
      _c("header-cmp"),
      _vm._v(" "),
      _c("section", { staticClass: "page-part banner banner_productcenter" }),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      _c("footer-cmp")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "section",
      { staticClass: "page-part client huozhu", attrs: { id: "huozhu" } },
      [
        _c("div", { staticClass: "page-inner" }, [
          _c("img", {
            attrs: {
              src: require("../assets/images/page_productcenter/huozhu.png"),
              alt: "货主端"
            }
          }),
          _vm._v(" "),
          _c("section", { staticClass: "img-desc" }, [
            _c("h3", { staticClass: "page-title" }, [_vm._v("货主端")]),
            _vm._v(" "),
            _c("span", { staticClass: "page-desc" }, [
              _vm._v(
                "享运货主版APP是一款大宗商品发货APP软件（运输类型包含钢材、熟料颗粒、木材、石材、机械设备等产品），将为广大货主提供在线询价快速报价、在线发货轻松管理、帐单查询一目了然、车辆定位实时追踪等功能。"
              )
            ])
          ])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "section",
      { staticClass: "page-part client siji bg", attrs: { id: "siji" } },
      [
        _c("div", { staticClass: "page-inner" }, [
          _c("section", { staticClass: "img-desc" }, [
            _c("h3", { staticClass: "page-title" }, [_vm._v("司机端")]),
            _vm._v(" "),
            _c("span", { staticClass: "page-desc" }, [
              _vm._v(
                "享运司机版APP是一款大宗商品车辆运输接单的APP，将为广大司机提供实时货源快速抢单、路线管理轻松找活、新车购买价格实惠、帐单查询一目了然等功能。"
              )
            ])
          ]),
          _vm._v(" "),
          _c("img", {
            attrs: {
              src: require("../assets/images/page_productcenter/siji.png"),
              alt: "司机端"
            }
          })
        ])
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-2eaf505a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-2eaf505a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/views/productcenter.vue
// module id = null
// module chunks = 